import { DOMcreateElement } from '../typescript/TSXDomParse';
export default function TicketCommitButton(_a) {
    var data = _a.data, icon = _a.icon, showTicketCount = _a.showTicketCount;
    var commitButtonHref = "https://tickets.spartan.com/api/shoppingCart/add/";
    var commitButtonHrefParams = ["goToCheckout=1"];
    showTicketCount || (showTicketCount = false);
    // Adds data as bracket notated url params
    for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
        var ticket = data_1[_i];
        var key = "ticketTypeId_" + ticket.ts_id;
        commitButtonHrefParams.push("cartTasks[" + key + "][quantity]=" + ticket.count);
        commitButtonHrefParams.push("cartTasks[" + key + "][eventId]=" + ticket.e_id);
        commitButtonHrefParams.push("cartTasks[" + key + "][typeId]=" + ticket.ts_id);
    }
    return (DOMcreateElement("a", { href: commitButtonHref + "?" + commitButtonHrefParams.join('&'), className: "commit cta-1" },
        DOMcreateElement("span", null,
            "Commit Now",
            (icon === null || icon === void 0 ? void 0 : icon.length) ? (DOMcreateElement("span", { className: "race-ticket-icon", style: "background-image: url('" + icon + "');" }, showTicketCount ? (DOMcreateElement("span", { className: "qty-overlay" }, data.length)) : (''))) : (''))));
}
